import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit"
import { localizationReducer } from "../localization/localizationSlice"
import { contextReducer } from "../context/contextSlice"
import { configReducer } from "../config/configSlice"
import { loginReducer, login, logout } from "../login/loginSlice"
import { userReducer } from "../users/userSlice"
import { errorReducer } from "../../shared/components/errors/store/errorSlice"
import { nonAdminUserReducer } from "../nonAdminUser/nonAdminUserSlice"
import { serviceCenterReducer } from "../serviceCenter/store/serviceCenterSlice"
import { priceListSelectionReducer } from "../merchant/admin/priceList/priceListSelectionSlice"
import { queryClient } from "../../core/api/queryClient"

// Create listener middleware to clear React Query cache on login/logout
const listenerMiddleware = createListenerMiddleware()

// Clear cache on logout to prevent data leakage between users
listenerMiddleware.startListening({
    actionCreator: logout,
    effect: async (_action, _listenerApi) => {
        queryClient.clear()
    },
})

// Clear cache on login to prevent showing previous user's cached data
listenerMiddleware.startListening({
    actionCreator: login,
    effect: async (_action, _listenerApi) => {
        queryClient.clear()
    },
})

export const store = configureStore({
    reducer: {
        login: loginReducer,
        user: userReducer,
        localization: localizationReducer,
        context: contextReducer,
        config: configReducer,
        nonAdminUser: nonAdminUserReducer,
        serviceCenter: serviceCenterReducer,
        error: errorReducer,
        priceListSelection: priceListSelectionReducer,
    },
    // Prepend listener middleware to run BEFORE default middleware (thunk, etc.)
    // This ensures cache clearing happens immediately when login/logout actions are dispatched,
    // preventing any cached data from persisting between user sessions
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
